// Schemas
import { discountListSchema, currencyListSchema } from 'modules/price/models'

// Types
import { APIAction } from 'types'

export const actions = {
  fetchGeneralDiscounts: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_GENERAL_DISCOUNTS',
      method: 'GET',
      endpoint: '/api/discounts/',
      schema: discountListSchema,
    },
  }),
  fetchUserDiscounts: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_USER_DISCOUNTS',
      method: 'GET',
      endpoint: '/api/discounts/user',
      schema: discountListSchema,
    },
  }),
  fetchCurrencies: (): APIAction => ({
    CALL_API: {
      type: 'FETCH_CURRENCIES',
      method: 'GET',
      endpoint: '/api/currencies',
      schema: currencyListSchema,
    },
  }),
}
